export default __webpack_public_path__ + "static/desktop_12-9bddf3f634d97399126c0ec96fbe300b.webp";